module.exports = __webpack_public_path__ + "static/media/logo.6e042c78.svg";